var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ChangePasswordForm',{on:{"onSubmit":_vm.changePassword}}),(_vm.showFinalePopup)?_c('FinalePopup',{attrs:{"subMessage":_vm.$t("POPUP.FINALY.ASIDE")},on:{"close":function($event){return _vm.$router.push({ name: "ProfileContactDetailsPage" })}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }